import './text.css';
// import TimePicker from 'react-time-picker';
function Text({dob, place, meetingTime, period, handleDOBChange, handleTimeChange, handlePlaceChange, handlePeriodChange}) {

  const handleDOB = (event) => {
    handleDOBChange(event.target.value);
  }
  
  const handleTime = (event) => {
    handleTimeChange(event.target.value);
  };

  const handlePlace = (event) => {
    handlePlaceChange(event.target.value);
  }

  const handlePeriod = (event) => {
    handlePeriodChange(event.target.value);
  };

  return (
    <div >
      {/* <h1>Enter Your Information</h1>
      <label>Date of Birth:</label>
      <input type="date" value={dob} onChange={handleDOB} />

      <label>
        Time:
        <input type="time" value={meetingTime} onChange={handleTime} />
      </label>
      <label>
        Period:
        <select value={period} onChange={handlePeriod}>
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </select>
      </label>
      <label>Place:</label>
      <input type="text" value={place} onChange={handlePlace} /> */}

      <div className="profile-form-body">
            {/* Birth Information Section */}
            <div className="form-section-title">Birth Information</div>
            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Date of Birth</label>
                  <input 
                    type="date" 
                    className="form-control" 
                    value={dob} 
                    onChange={handleDOB} 
                    required 
                  />
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Time of Birth</label>
                  <div className="time-input-group">
                    <input 
                      type="time" 
                      className="form-control time-input" 
                      value={meetingTime} 
                      onChange={handleTime} 
                      required 
                    />
                    <select 
                      className="form-control period-select" 
                      value={period} 
                      onChange={handlePeriod}
                    >
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="form-group">
              <label className="form-label">Place of Birth</label>
              <input 
                type="text" 
                className="form-control" 
                placeholder="Enter your birth place" 
                value={place} 
                onChange={handlePlace} 
                required 
              />
            </div>

                        
          </div>
    </div>

  );
}

export default Text;